import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=10228316&scoped=true"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"
import style0 from "./Share.vue?vue&type=style&index=0&id=10228316&prod&lang=css"
import style1 from "./Share.vue?vue&type=style&index=1&id=10228316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10228316",
  null
  
)

export default component.exports